import { render, staticRenderFns } from "./Bidinput.vue?vue&type=template&id=928bc1f2&scoped=true&"
import script from "./Bidinput.vue?vue&type=script&lang=js&"
export * from "./Bidinput.vue?vue&type=script&lang=js&"
import style0 from "./Bidinput.vue?vue&type=style&index=0&id=928bc1f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928bc1f2",
  null
  
)

export default component.exports